const READ_BY_EAR_CHECKOUT_HOST = "checkout.read-by-ear.com";
const SARA_CHECKOUT_HOST = "checkout.sara.ai";

/**
 * The checkout host to name on the landing page: the mirror the visitor
 * actually reached, since that is the one on their card statement or in
 * their browser bar. Staging, preview and localhost read as sara.ai.
 */
export function displayCheckoutHost(hostname: string): string {
  return hostname === READ_BY_EAR_CHECKOUT_HOST
    ? READ_BY_EAR_CHECKOUT_HOST
    : SARA_CHECKOUT_HOST;
}
